import ShareModal from './ShareModal';

export default ShareModal;
